<template>
  <div class="contents_wrapper">
    <div class="contents">
      <p>1. 銀行情報を確認してください</p>
      <p>銀行コード</p>
      <input class="text_form" type="number" v-model="bankNumber">
      <p>支店コード</p>
      <input class="text_form" type="number" v-model="branchNumber">
      <p>口座番号</p>
      <input class="text_form" type="number" v-model="stripeParams.bank.account_number">
      <p>口座名義</p>
      <input class="text_form" type="text" v-model="stripeParams.bank.account_holder_name">

      <p>2. 利用規約を確認してください</p>
      <p><input type="checkbox"  id="terms_check_id" v-model="isTermsCheck"/>
        <label for="terms_check_id"> 私は<a target="_blank" href="/information/terms" class="link_label">利用規約</a>に同意します。</label>
      </p>

      <button v-if="isTermsCheck" @click="registerBank()" class="active-rectangle_button">アカウントの認証をする</button>
      <button v-else class="inactive-rectangle_button">利用規約に同意してください</button>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import caller from "@/assets/js/functions/firebase/cloud_functions/caller";
  import toast from "@/assets/js/functions/_core/toast";

  export default {
    name: "RegistrationBank",

    mixins: [caller, toast],

    data() {
      return {
        isTermsCheck: false,
        bankNumber: '',
        branchNumber: '',

        stripeParams: {
          bank: {
            routing_number: '',
            account_number: '',
            account_holder_name: '',
          }
        },
      }
    },

    computed: {
      ...mapGetters({uid: 'auth/uid'}),

      isValid() {
        if (!this.bankNumber || !this.branchNumber || !this.stripeParams.bank.account_number || !this.stripeParams.bank.account_holder_name) {
          this.showErrorMessage('未入力のデータがあります。');
          return false;
        }
        return true;
      },
    },

    watch: {
      bankNumber: function (val) {
        this.stripeParams.bank.routing_number = val + this.branchNumber;
      },
      branchNumber: function (val) {
        this.stripeParams.bank.routing_number = this.bankNumber + val;
      },
    },


    methods: {
      async registerBank() {
        if (!this.isValid) return;

        const params = {
          userId: this.uid,
          stripeParams: this.stripeParams
        };

        await this.callFunction(
          'createStripeBank',
          params
        ).then(() => {
          this.showSuccessMessage('銀行口座情報を更新しました。');
          this.$router.push({name: 'OperatorTop'});
        }).catch(error => {
          this.showErrorMessage(error.message);
        });
      },
    },
  }
</script>

<style lang="scss" scoped>
  .contents_wrapper {
    background-color: $operator_primary;
    > .contents {
      @include form-contents();

      > div, > p, .uploader-serverless-form_box, .verifying-person, .verifying-company, .verifying-individual {
        width: 100%;
      }
    }
  }
</style>